import { createMomentCustomField } from './create'
import { notifyMomentCustomField } from './notify'
import { readMomentCustomFields } from './read'
import { resourceObject } from './resourceObject'
import { updateMomentCustomField } from './update'

export const momentCustomField = {
  clientResource: resourceObject,
  create: createMomentCustomField,
  readCollection: readMomentCustomFields,
  notify: notifyMomentCustomField,
  update: updateMomentCustomField,
}
